var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tw-list-disc tw-list-outside tw-space-y-2 tw-pl-5"},_vm._l((_vm.countryQuestions),function(question,index){return _c('li',{key:index},[_vm._v("\n        "+_vm._s(question)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }